export const DEEP_LINKS_FF_KEY = 'show-open-in-app';
export const ANDROID_APP_PACAKGE = 'com.plangrid.android';
export const IOS_APP_SCHEME = 'plangrid';
export const IOS_APP_STORE_URL =
  'https://apps.apple.com/us/app/plangrid/id498795789';
export const DEEP_LINKS_PARAM_KEY = 'continue_in_web';
export const MOBILE_SUPPORTED_PATH_PATTERNS = [
  '/projects',
  '/projects/*',
  '/home',
  '/home/*',
  '/build/sheets/*',
  '/build/files/*',
  '/build/demo-app/*',
  '/docs/files/*',
  '/build/forms/*',
];
export const TIMEOUT_TO_OPEN_STORE_URL_IN_MS = 500;
